export const smallBreakpoint = 720;

const config = {
  small: {
    className: "viewportSmall",
    mediaQuery: `(width <= ${smallBreakpoint}px)`,
  },
  large: {
    className: "viewportLarge",
    mediaQuery: `(width > ${smallBreakpoint}px)`,
  },
};

export default config;
